export const state = {
  pettycashes: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/state.js